<template>
  <div>
    <template v-if="comp_load">
      <div
        class="container"
        style="background-color: white; height: 474px; margin-top: 0px"
      ></div>
      <div v-for="(stud_data, ind) in card_stud_data" :key="ind">
        <div
          class="container"
          style="background-color: white; height: 474px"
        >
          <div class="row" style="width: 18rem">
            <div class="col-12 cardArea">
              <div style="background-color: white">
                <center>
                  <img
                    :src="card_org_data.school_logo"
                    style="width: 80%; margin-bottom: -10px"
                    alt="logo"
                  />
                </center>
              </div>
            </div>
            <div class="col-12 "
              style="
                background-color: white; padding: 0;
              "
            ><center>
              <span
                    style="
                      font-weight: bold;
                      color: red;
                      text-transform: uppercase;
                      font-size: small;
                    "
                    >Father Icard</span
                  ><br />
              <span
                    style="color: #114b7b; font-size: small; font-weight: bold;margin-top: -5px;"
                    >{{ card_org_data.school_address }}</span
                  ><br />
            </center>
            </div>
            <div class="row" style="justify-content:center;">
              
              <div class="col-5">
               <img
                  :src="stud_data.fphoto"
                  width="100%"
                  height="120px"
                  alt="father_photo"
                  style="border: 1px solid black"
                /> 
              </div>
            </div>

            <div
              style="
                color: #114b7b;
                font-size: small;
                margin-left: 6%;
                width: 100%;                
              "
            >
            <span><b>Father Name:</b> &nbsp; {{ stud_data.father_name }}</span>
            <br />
            <span><b>Contact No.:</b> &nbsp; {{ stud_data.father_contact_no }}</span>
            <br /><br />
             <center>
                <qrcode-vue style="margin-left: -20px;" :value="stud_data.prn" :size="55"></qrcode-vue>
             </center>
            </div>

            <br />
          </div>
        </div>
        <div class="container pagebreak" style="background-color: white; height: 474px">
          <div
            class="row"
            style="
              width: 18rem;
              height: 480px;
              background-color: white;
              margin-top: -15px;
            "
          >
            <div
              class="col-12 cardArea"
              style="background-color: white; height: 462px"
            >
              <div style="background-color: white">
                <center>
                  <img
                    :src="card_org_data.school_logo"
                    style="width: 80%; margin-bottom: -15px"
                    alt="logo"
                  />
                </center>
              </div>
              <div style="background-color: white; height: 100px">
                <center>                 
                  <span
                    style="color: #114b7b; font-size: small; font-weight: bold"
                    >{{ card_org_data.school_address }}</span
                  ><br />
                </center>
              </div>
              <div class="empty-div"><center >{{ stud_data.stud_name }}</center></div>
              <div class="row">
                <div class="col-8" style="color: #114b7b; font-size: 10px">
                  <span><b>Grade :</b> &nbsp;{{ stud_data.grade }}</span
                  ><br />
                  <span><b>D.O.B.:</b> &nbsp;{{ stud_data.dob }}</span
                  ><br />
                  <span><b>Blood Group:</b> &nbsp;{{ stud_data.bloodgrp }}</span
                  ><br />
                  <span
                    ><b>Transportation Mode:</b> &nbsp;
                    {{ stud_data.transportationmode }}</span
                  ><br />
                  <span
                    ><b>Permanent Address:</b>&nbsp;
                    {{ stud_data.paddress }}</span
                  ><br />
                </div>
                <div class="col-4">
                  <img
                    :src="stud_data.sphoto"
                    style="border: 1px solid black"
                    width="100%"
                    height="96px"
                    alt="logo"
                  />
                </div>
              </div>
              <div style="line-height: 1; margin-top: 1%">
                <img
                  :src="card_org_data.auth_sign"
                  style="width: 20%; height: 40px; margin-left: 70%"
                  alt="logo"
                />
                <span style="margin-left: 70%; color: #114b7b">Auth.Sign.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>{{ msg }}</template>
  </div>
</template>

<script>
import axios from "axios";
import QrcodeVue from "qrcode.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
        QrcodeVue,
    },
  data: () => ({
    card_stud_data: null,
    card_org_data: null,
    msg: "Please wait....",
    comp_load: false,
    status:null,
  }),
  mounted() {
    this.std = localStorage.getItem("icard_std_id");
    this.div = localStorage.getItem("icard_div_id");
    this.status = localStorage.getItem("icard_learner_status");
    this.bulkEscort();
  },

  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    async bulkEscort() {
      const data = {
        std: this.std,
        div: this.div,
        status:this.status
      };
      this.comp_load = false;
      try {
        const res = await axios.post("/Icard/bulkEscort", data);
        console.log("result", res.data);
        if (res.data.flag == "YES") {
          this.card_stud_data = res.data.card_stud_data;
          this.card_org_data = res.data.card_org_data;
        } else {
          alert(res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
      } catch (err) {
        alert("Something went wrong...");
      } finally {
        this.comp_load = true;
        this.msg = "";
      }
    },
  },
};
</script>


<style scoped>
.cardArea {
  padding: 0;
  padding-left: 6px;
}
@media print {
  .pagebreak {
    page-break-before: always !important;
  }
  @page {
    margin: -0.2645833mm;
    size: 53mm 86.614mm;
  }
}
.empty-div {
  background-color: #114b7b;
  height: 23px;
  color:yellow;
  width: 18.5rem;
  margin-left: -4px;
}
</style>